import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=5a5ff3b3&"
import script from "../descriptors/datepicker.js?vue&type=script&lang=js&"
export * from "../descriptors/datepicker.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports